const trimText = (endCount, string) => {
  if (string && string.length > endCount) {
    return string.substr(0, endCount).concat('...');
  } else {
    return string;
  }
};

export default trimText;
